<template>
  <div id="tags-view-container" class="tags-view-container">
    <scroll-pane ref="scrollPane" class="tags-view-wrapper" @scroll="handleScroll">
      <router-link
        v-for="tag in visitedViews"
        ref="tag"
        :key="`${tag.path}${JSON.stringify(tag.query || {})}`"
        :class="isActive(tag)?'active':''"
        :to="{ path: tag.path, query: tag.query, fullPath: tag.fullPath }"
        tag="span"
        class="tags-view-item"
        @click.middle.native="!isAffix(tag)?closeSelectedTag(tag):''"
        @contextmenu.prevent.native="openMenu(tag,$event)"
      >
        {{ tag.title }}
        <span v-if="!isAffix(tag)" class="el-icon-close" @click.prevent.stop="closeSelectedTag(tag)" />
      </router-link>
    </scroll-pane>
    <ul v-if="visible" :style="{left:left+'px',top:top+'px'}" class="contextmenu">
      <li @click="refreshSelectedTag(selectedTag)">{{ $t('msg.flushButton') }}</li>
      <li v-if="!isAffix(selectedTag)" @click="closeSelectedTag(selectedTag)">{{ $t('msg.closeButton') }}</li>
      <li @click="closeOthersTags">{{ $t('msg.closeOtherButton') }}</li>
      <!-- <li @click="closeAllTags(selectedTag)">关闭所有</li> -->
    </ul>
  </div>
</template>

<script>
import ScrollPane from './ScrollPane.vue'
import path from 'path'
import comparePath from '../../../../utils/comparePath'

export default {
  components: { ScrollPane },
  data() {
    return {
      visible: false,
      top: 0,
      left: 0,
      selectedTag: {},
      affixTags: []
    }
  },
  computed: {
    visitedViews() {
      if (this.$store.state.tagsView.visitedViews.length > 0) {
        this.$store.state.tagsView.visitedViews.forEach(item => {
          if (item.path === '/home') {
            item.title = this.$t('msg.home')
          }
          if (item.path === '/aboutIndex') {
            item.title = this.$t('msg.contractManagementMenu')
          }
          if (item.path.search('aboutDetails') !== -1) {
            item.title = this.$t('msg.contractDetailMenu')
          }
          if (item.path.search('freightDetails') !== -1) {
            item.title = this.$t('msg.rateDetailMenu')
          }
          if (item.path.search('freightRecordsDetails') !== -1) {
            item.title = this.$t('msg.rateRecordsDetails')
          }
          if (item.path === '/freightProprietary') {
            item.title = this.$t('msg.contractRateMenu')
          }
          if (item.path === '/freightOnline') {
            item.title = this.$t('msg.eCommerceRateMenu')
          }
          if (item.path === '/freightPeer') {
            item.title = this.$t('msg.offlineRateMenu')
          }
          if (item.path === '/product') {
            item.title = this.$t('msg.productManagementMenu')
          }
          if (item.path === '/freightAll') {
            item.title = this.$t('msg.rateTotalTableMenu')
          }
          if (item.path === '/freightRecords') {
            item.title = this.$t('msg.rateRecordsMenu')
          }
          if (item.path === '/surchargeRules') {
            item.title = this.$t('msg.surchargeRulesMenu')
          }
          if (item.path === '/surchargeDetails') {
            item.title = this.$t('msg.surchargeDetailsMenu')
          }
          if (item.path.search('surchargeRulesDetails') !== -1) {
            item.title = this.$t('msg.surchargeRuleDetailMenu')
          }
          if (item.path === '/inlandFreight') {
            item.title = this.$t('msg.inlandFreightMenuNew')
          }
          if (item.path === '/cabin') {
            item.title = this.$t('msg.distributionRateMenu')
          }
          if (item.path.search('cabinDetails') !== -1) {
            item.title = this.$t('msg.distributionDetailMenu')
          }
          if (item.path === '/cabinRules') {
            item.title = this.$t('msg.distributionMarkupTitle')
          }
          if (item.path === '/cabinAutomatic') {
            item.title = this.$t('msg.automaticDistributionRateMenu')
          }
          if (item.path === '/tag') {
            item.title = this.$t('msg.tagManagement')
          }
          if (item.path === '/subscribe') {
            item.title = this.$t('msg.rateSubscribed')
          }
          if (item.path === '/premium') {
            item.title = this.$t('msg.markupManagement')
          }
          if (item.path === '/free') {
            item.title = this.$t('msg.freeDetentionMenu')
          }
          if (item.path.search('freeDetails') !== -1) {
            item.title = this.$t('msg.freeDetentionDetailMenu')
          }
          if (item.path === '/prebooking') {
            item.title = this.$t('msg.prebookingMenu')
          }
          if (item.path === '/bulkCargo') {
            item.title = this.$t('msg.generalCargoSchedule')
          }
          if (item.path === '/uploadList') {
            item.title = this.$t('msg.uploadRecordMenu')
          }
          if (item.path.search('prebookingDetails') !== -1) {
            item.title = this.$t('msg.prebookingDetailMenu')
          }
          if (item.path.search('prebookingDetails') !== -1) {
            item.title = this.$t('msg.prebookingDetailMenu')
          }
          if (item.path === '/systemSetting') {
            item.title = this.$t('msg.systemSettingMenu')
          }
          if (item.path === '/offlineRate') {
            item.title = this.$t('msg.offlineRateMenu')
          }
          if (item.path === '/inlandCarriage') {
            item.title = this.$t('msg.inlandFreightMenuNew')
          }
          if (item.path.indexOf('inlandDetails') > -1) {
            item.title = this.$t('msg.inlandFreightDetails')
          }
          if (item.path === '/queryLog') {
            item.title = this.$t('msg.searchRecs')
          }
        })
      }
      return this.$store.state.tagsView.visitedViews
    },
    routes() {
      return this.$store.state.permission.routes
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.addTags()
          this.moveToCurrentTag()
        }
      },
      deep: true
    },
    visible(value) {
      if (value) {
        document.body.addEventListener('click', this.closeMenu)
      } else {
        document.body.removeEventListener('click', this.closeMenu)
      }
    }
  },
  methods: {
    isActive(route_1) {
      const route_2 = this.$route

      return comparePath(route_1, route_2)
    },
    // 是否固定
    isAffix(tag) {
      if (tag.meta && tag.meta.affix) {
        return true
      } else if (this.visitedViews.length === 1) {
        return true
      }
      return false
    },
    filterAffixTags(routes, basePath = '/') {
      let tags = []
      routes.forEach(route => {
        if (route.meta && route.meta.affix) {
          const tagPath = path.resolve(basePath, route.path)
          tags.push({
            fullPath: tagPath,
            path: tagPath,
            name: route.name,
            meta: { ...route.meta }
          })
        }
        if (route.children) {
          const tempTags = this.filterAffixTags(route.children, route.path)
          if (tempTags.length >= 1) {
            tags = [...tags, ...tempTags]
          }
        }
      })
      return tags
    },
    initTags() {
      const affixTags = this.affixTags = this.filterAffixTags(this.routes)
      for (const tag of affixTags) {
        // Must have tag name
        if (tag.name) {
          this.$store.dispatch('tagsView/addVisitedView', tag)
        }
      }
    },
    addTags() {
      const { name } = this.$route
      if (name) {
        this.$store.dispatch('tagsView/addView', this.$route)
      }
      return false
    },
    moveToCurrentTag() {
      if (this.$refs.tag) {
        const tags = this.$refs.tag
        this.$nextTick(() => {
          for (const tag of tags) {
            if (tag.to.path === this.$route.path) {
              if (tag.to.fullPath !== this.$route.fullPath) {
                this.$store.dispatch('tagsView/updateVisitedView', this.$route)
              }
              break
            }
          }
        })
      }
    },
    // 刷新
    refreshSelectedTag(view) {
      this.$store.dispatch('tagsView/delCachedView', view).then(() => {
        const { fullPath } = view
        this.$nextTick(() => {
          if (fullPath !== this.$route.fullPath) {
            this.$router.push({ path: fullPath })
          } else {
            // 空白页面中转
            this.$router.replace({
              path: '/redirect' + fullPath
            })
          }
        })
      })
    },
    // 关闭当前
    closeSelectedTag(view) {
      this.$store.dispatch('tagsView/delView', view).then(({ visitedViews }) => {
        if (this.isActive(view)) {
          this.toLastView(visitedViews, view)
        }
      })
    },
    // 关闭其他
    closeOthersTags() {
      if (this.selectedTag.fullPath !== this.$route.fullPath) {
        this.$router.push(this.selectedTag)
      }
      this.$store.dispatch('tagsView/delOthersViews', this.selectedTag).then(() => {
        this.moveToCurrentTag()
      })
    },
    // 关闭所有
    closeAllTags(view) {
      this.$store.dispatch('tagsView/delAllViews').then(({ visitedViews }) => {
        if (this.affixTags.some(tag => tag.path === view.path)) {
          return
        }
        this.toLastView(visitedViews, view)
      })
    },
    toLastView(visitedViews, view) {
      const latestView = visitedViews.slice(-1)[0]
      if (latestView) {
        this.$router.push(latestView.fullPath)
      } else {
        // 逻辑待定
        this.$router.push(`/${this.appId}`)
      }
    },
    openMenu(tag, e) {
      const menuMinWidth = 105
      const offsetLeft = this.$el.getBoundingClientRect().left // container margin left
      const offsetWidth = this.$el.offsetWidth // container width
      const maxLeft = offsetWidth - menuMinWidth // left boundary
      const left = e.clientX - offsetLeft + 15 // 15: margin right

      if (left > maxLeft) {
        this.left = maxLeft
      } else {
        this.left = left
      }

      this.top = e.clientY
      this.visible = true
      this.selectedTag = tag
    },
    closeMenu() {
      this.visible = false
    },
    handleScroll() {
      this.closeMenu()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../styles/variables.scss';
.tags-view-container {
  height: 34px;
  width: 100%;
  background:#F1F2F3;
  border-bottom: 1px solid #dedede;
  .tags-view-wrapper {
    .tags-view-item {
      display: inline-block;
      position: relative;
      cursor: pointer;
      height: 26px;
      line-height: 26px;
      border: 1px solid #d8dce5;
      color: #333333;
      background: #fff;
      padding: 0 8px;
      font-size: 12px;
      margin-left: 5px;
      margin-top: 4px;
      &:first-of-type {
        margin-left: 15px;
      }
      &:last-of-type {
        margin-right: 15px;
      }
      &.active {
        color: var(--geek-color-primary);
        &::before {
          content: '';
          background:var(--geek-color-primary);
          display: inline-block;
          width: 8px;
          height: 8px;
          border-radius: 50%;
          position: relative;
          margin-right: 2px;
        }
      }
    }
  }
  .contextmenu {
    margin: 0;
    background: #fff;
    z-index: 3000;
    position: absolute;
    list-style-type: none;
    padding: 5px 0;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 400;
    color: #333;
    box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, .3);
    li {
      margin: 0;
      padding: 7px 16px;
      cursor: pointer;
      &:hover {
        background: #eee;
      }
    }
  }
}
</style>

<style lang="scss">
//reset element css of el-icon-close
.tags-view-wrapper {
  .tags-view-item {
    .el-icon-close {
      width: 16px;
      height: 16px;
      vertical-align: 2px;
      border-radius: 50%;
      text-align: center;
      transition: all .3s cubic-bezier(.645, .045, .355, 1);
      transform-origin: 100% 50%;
      &:before {
        transform: scale(1);
        display: inline-block;
        vertical-align: -3px;
      }
      &:hover {
        //background-color: #b4bccc;
        color: red;
      }
    }
  }
}
</style>
